import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

import emailValidation from '~/utilities/emailValidation'
import * as TrafficTicketService from '~/services/trafficTicket'

import CheckBlueCircle from '~/public/static/images/svg/checkBlueCircleIcon.svg'
import peaceOut from '~/public/static/images/png/peaceOut.png'

import Center from '~/components/basic/Center'
import Spacer from '~/components/Spacer'

import SectionHeader from '~/components/Pages/SectionHeader'

@inject(all => ({
  trafficSubmission: all.store.trafficSubmission,
  selectedState: all.store.trafficSubmission.selectedState,
  user: all.store.auth.user,
  toasts: all.store.ui.toasts,
  isMobile: all.store.ui.isMobile
}))
@observer
class NotThereYetModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      saved: false,
      invalidEmail: false,
      email: props.user.email || ''
    }
  }

  changeState = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value
    })
  }

  handleEmailChange = event => {
    this.changeState('email', event.target.value.toLowerCase().trim())
  }

  saveInfo = async event => {
    if (event && event.preventDefault) event.preventDefault()
    const isEmailValid = emailValidation(this.state.email)
    if (!isEmailValid) return this.changeState('invalidEmail', true)
    this.changeState('loading', true)
    TrafficTicketService.saveOutOfArea(
      this.state.email,
      this.props.selectedState.shortName
    )
      .then(() => {
        this.changeState('saved', true)
        this.changeState('loading', false)
      })
      .catch(error => {
        this.changeState('loading', false)
        this.props.toasts.addToast({
          message: `Issue saving your vote: ${error}`,
          type: 'ERROR'
        })
      })
  }

  render() {
    const { isMobile, selectedState } = this.props
    if (this.state.loading) {
      return (
        <Center fillParent>
          <div>Saving Your Vote!</div>
          <div>This will just take a second.</div>
        </Center>
      )
    }
    if (this.state.saved) {
      return (
        <Center fillParent>
          <img src={CheckBlueCircle} alt='success' />
          <SectionHeader text='Great, we will keep you posted' />
        </Center>
      )
    }
    return (
      <Center>
        <Spacer desktop={20} mobile={40} />
        <img src={peaceOut} alt='Peace Out Tickets!' />
        <SectionHeader
          title='Under Maintenance'
          color="orange"
        />
      </Center>
    )
  }
}

NotThereYetModal.defaultProps = {}

NotThereYetModal.propTypes = {
  hideModal: PropTypes.func.isRequired
}

export default NotThereYetModal
